import React, { useState, useEffect } from "react";
import axios from "axios";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import * as Yup from "yup";
import _ from "lodash";
import ConfirmationModal from '../shared/ConfirmationModal';
import NewconfirmationModal from "../shared/NewconfirmationModal";
import AllFailureModal from "../shared/AllFailureModal";

const JobUpdate = () => {
  const { jobid } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [searchTerm, setSearchTerm] = useState({ company: "", hr: "" });
  const [filteredResults, setFilteredResults] = useState({ companies: [], hrs: [] });
  const [showDropdown, setShowDropdown] = useState({ company: false, hr: false });
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");
  const [pendingSubmitValues, setPendingSubmitValues] = useState(null);
  const jobsInitialState = {
    job_id: jobid,
    job_name: "",
    //job_category: "",
    company_id: "",
    company_name: "",
    hr_id: "",
    hr_name: "",
    post_date: "",
    end_date: ""
  };

  const [updateData, setUpdateData] = useState(jobsInitialState);
  const [categories, setCategories] = useState([]);
  const [loader, setLoader] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [hrs, setHrs] = useState([]);

  const validationSchema = Yup.object().shape({
    job_name: Yup.string()
      .required("Job name is required")
      .min(3, "Job name must be at least 3 characters long"),
    // job_category: Yup.string().required("Job category is required"),
    company_id: Yup.string().required("Company selection is required"),
    company_name: Yup.string().required("Company name is required"),
    hr_id: Yup.string().required("HR selection is required"),
    hr_name: Yup.string().required("HR name is required"),
    post_date: Yup.date().required("Post date is required"),
    end_date: Yup.date()
      .required("End date is required")
      .min(
        Yup.ref("post_date"),
        "End date cannot be before post date"
      )
  });

  // const fetchCategories = async () => {
  //   try {
  //     setLoader(true);
  //     const url = `${process.env.REACT_APP_API_URL}category/getcategory`;
  //     const response = await axios.get(url);
  //     setCategories(response?.data);
  //   } catch (error) {
  //     console.error("Error fetching categories:", error);
  //     setError("Failed to fetch categories. Please try again later.");
  //   } finally {
  //     setLoader(false);
  //   }
  // };

  const fetchCompanies = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}companyDetails/companylist`);
      setCompanies(response.data.companies || response?.data);
    } catch (error) {
      console.error("Error fetching companies:", error);
      setError("Failed to fetch companies. Please try again later.");
    }
  };

  const fetchHrs = async (company_id) => {
    try {
      const url = company_id
        ? `${process.env.REACT_APP_API_URL}hr_details/showallhr_details/${company_id}`
        : `${process.env.REACT_APP_API_URL}hr_details/showallhr_details`;

      const response = await axios.get(url);

      const hrArray = response.data?.hrs;

      if (Array.isArray(hrArray)) {
        setHrs(hrArray); 
      } else {
        console.error("Expected hrs to be an array:", hrArray);
        setHrs([]); 
      }
    } catch (error) {
      console.error("Error fetching HRs:", error);
      setError("Failed to fetch HR details");
      setHrs([]);
    }
  };

  const getJobByIDApi = async (jobid) => {
    try {
      setLoader(true);
      const url = `${process.env.REACT_APP_API_URL}jobs/showjobbyid/${jobid}`;
      const response = await axios.get(url);
      const jobData = response.data[0] || {};
      jobData.job_id = jobData.job_id || jobid;
      jobData.job_name = jobData.job_name || "";
      jobData.company_id = jobData.company_id || "";
      jobData.company_name = jobData.company_name || "";
      jobData.hr_id = jobData.hr_id || "";
      jobData.hr_name = jobData.hr_name || "";
      jobData.post_date = jobData.post_date ? jobData.post_date.split('T')[0] : "";
      jobData.end_date = jobData.end_date ? jobData.end_date.split('T')[0] : "";

      setUpdateData(jobData);
      setSearchTerm({
        company: jobData.company_name,
        hr: jobData.hr_name
      });
    } catch (error) {
      console.error("Error fetching job details:", error);
      setError("Failed to fetch job details. Please try again later.");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    //fetchCategories();
    fetchCompanies();
    fetchHrs();
    getJobByIDApi(jobid);
  }, [jobid]);

  const handleSearch = (type, value) => {
    setSearchTerm({ ...searchTerm, [type]: value });
    setShowDropdown({ ...showDropdown, [type]: true });

    const filtered = type === 'company'
      ? companies.filter(company =>
        company.company_name.toLowerCase().includes(value.toLowerCase())
      )
      : hrs.filter(hr =>
        hr.name.toLowerCase().includes(value.toLowerCase())
      );

    setFilteredResults({
      ...filteredResults,
      [type === 'company' ? 'companies' : 'hrs']: filtered
    });
  };

  const handleSelect = (type, item, setFieldValue) => {
    if (type === 'company') {
      setFieldValue('company_id', item.company_id);
      setFieldValue('company_name', item.company_name);
      setSearchTerm({ ...searchTerm, company: item.company_name, hr: '' });
      setFieldValue('hr_id', '');
      setFieldValue('hr_name', '');
      setFilteredResults({ ...filteredResults, hrs: [] });
      fetchHrs(item.company_id);
    } else {
      setFieldValue('hr_id', item.userid);
      setFieldValue('hr_name', item.name);
      setSearchTerm({ ...searchTerm, hr: item.name });
    }
    setShowDropdown({ ...showDropdown, [type]: false });
  };



  const handleUpdateConfirmation = async () => {
    setModalShow(false);
    if (pendingSubmitValues) {
      try {
        await axios.put(`${process.env.REACT_APP_API_URL}jobs/updatejob`, pendingSubmitValues);
        setSuccessMessage("Job updated successfully.");
        setShowSuccessModal(true);
        setPendingSubmitValues(null);
        setTimeout(() => navigate('/joblist'), 3000);
      } catch (error) {
        console.error("Error updating job:", error);
        setFailureMessage("Failed to update job.");
        setShowFailureModal(true);
      }
    }
  };
  const handleSubmit = async (values) => {
    if (_.isEqual(values, updateData)) {
      setSuccessMessage("No changes were made.");
      setShowSuccessModal(true);
      return;
    }

    setModalMessage("Are you sure you want to update this job?");
    setModalShow(true);
    setPendingSubmitValues(values);
  };


  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="shadow">
            <Card.Header className="bg-info text-white text-center">
              <h4>Update Job</h4>
            </Card.Header>
            <Card.Body>
              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}
              <Formik
                enableReinitialize={true}
                initialValues={updateData}
                validationSchema={validationSchema}
                onSubmit={(handleSubmit)}
              >
                {({ values, setFieldValue, touched, errors }) => (
                  <Form>
                    <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="job_name" className="form-label">
                          Job Name *
                        </label>
                        <Field
                          name="job_name"
                          type="text"
                          className={`form-control ${touched.job_name && errors.job_name ? 'is-invalid' : ''}`}
                          placeholder="Enter Job Name"
                        />
                        <ErrorMessage
                          name="job_name"
                          component="div"
                          className="text-danger mt-1"
                        />
                      </Col>
                    </Row>

                    {/* <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="job_category" className="form-label">
                          Job Category *
                        </label>
                        {loader ? (
                          <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <Field
                            as="select"
                            name="job_category"
                            className={`form-select ${touched.job_category && errors.job_category ? 'is-invalid' : ''}`}
                          >
                            <option value="">Select a category</option>
                            {categories.map((category) => (
                              <option key={category.category_id} value={category.category_name}>
                                {category.category_name}
                              </option>
                            ))}
                          </Field>
                        )}
                        <ErrorMessage
                          name="job_category"
                          component="div"
                          className="text-danger mt-1"
                        />
                      </Col>
                    </Row> */}

                    <Row className="mb-3">
                      <Col md={12}>
                        <label className="form-label">Company *</label>
                        <div className="position-relative">
                          <input
                            type="text"
                            className={`form-control ${touched.company_name && errors.company_name ? 'is-invalid' : ''}`}
                            value={searchTerm.company}
                            onChange={(e) => handleSearch('company', e.target.value)}
                            placeholder="Search for a company..."
                            autoComplete="off"
                          />
                          {showDropdown.company && searchTerm.company && (
                            <div className="position-absolute w-100 mt-1 shadow bg-white border rounded" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                              {filteredResults.companies.map((company) => (
                                <div
                                  key={company.company_id}
                                  className="p-2 hover-bg-light cursor-pointer"
                                  onClick={() => handleSelect('company', company, setFieldValue)}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {company.company_name}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        <Field
                          name="company_id"
                          type="text"
                          className="form-control mt-2"
                          disabled
                          placeholder="Company ID"
                        />
                        <ErrorMessage
                          name="company_name"
                          component="div"
                          className="text-danger mt-1"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={12}>
                        <label className="form-label">HR *</label>
                        <div className="position-relative">
                          <input
                            type="text"
                            className={`form-control ${touched.hr_name && errors.hr_name ? 'is-invalid' : ''}`}
                            value={searchTerm.hr}
                            onChange={(e) => handleSearch('hr', e.target.value)}
                            placeholder="Search for an HR..."
                            autoComplete="off"
                          />
                          {showDropdown.hr && searchTerm.hr && (
                            <div className="position-absolute w-100 mt-1 shadow bg-white border rounded" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                              {filteredResults.hrs.map((hr) => (
                                <div
                                  key={hr.userid}
                                  className="p-2 hover-bg-light cursor-pointer"
                                  onClick={() => handleSelect('hr', hr, setFieldValue)}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {hr.name}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        <Field
                          name="hr_id"
                          type="text"
                          disabled
                          className="form-control mt-2"
                          placeholder="HR ID"
                        />
                        <ErrorMessage
                          name="hr_name"
                          component="div"
                          className="text-danger mt-1"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="post_date" className="form-label">
                          Post Date *
                        </label>
                        <Field
                          name="post_date"
                          type="date"
                          className={`form-control ${touched.post_date && errors.post_date ? 'is-invalid' : ''}`}
                        />
                        <ErrorMessage
                          name="post_date"
                          component="div"
                          className="text-danger mt-1"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="end_date" className="form-label">
                          End Date *
                        </label>
                        <Field
                          name="end_date"
                          type="date"
                          className={`form-control ${touched.end_date && errors.end_date ? 'is-invalid' : ''}`}
                        />
                        <ErrorMessage
                          name="end_date"
                          component="div"
                          className="text-danger mt-1"
                        />
                      </Col>
                    </Row>


                    <Row className="mt-4">
                      <Col className="text-center">
                        <Button type="submit" variant="success" className="me-2">
                          {loader ? 'Updating...' : 'Update Job'}
                        </Button>
                        <Button variant="danger" onClick={() => navigate(-1)}>
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ConfirmationModal
        show={modalShow}
        modalMessage={modalMessage}
        onHide={() => setModalShow(false)}
        confirmation={handleUpdateConfirmation}
        operationType="Update" />
      <NewconfirmationModal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        modalMessage={successMessage}
        operationType="OK"
        timeoutDuration={3000}
      />
      <AllFailureModal
        show={showFailureModal}
        onHide={() => setShowFailureModal(false)}
        modalMessage={failureMessage}
        operationType="OK"
        timeoutDuration={5000}
      />
    </Container>
  );
};

export default JobUpdate;